"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E_ContractType = exports.E_UnitMeasure = exports.E_MeasureType = exports.E_BodyPart = exports.E_BodyArea = exports.E_FitType = exports.E_GenderType = exports.E_ClothesType = exports.AlertWidgetType = exports.StatisticTypeWidget = exports.StatisticWidgetVariantValue = void 0;
var StatisticWidgetVariantValue;
(function (StatisticWidgetVariantValue) {
    StatisticWidgetVariantValue[StatisticWidgetVariantValue["REGULAR"] = 0] = "REGULAR";
    StatisticWidgetVariantValue[StatisticWidgetVariantValue["SUCCESS"] = 1] = "SUCCESS";
    StatisticWidgetVariantValue[StatisticWidgetVariantValue["DANGER"] = 2] = "DANGER";
})(StatisticWidgetVariantValue || (exports.StatisticWidgetVariantValue = StatisticWidgetVariantValue = {}));
var StatisticTypeWidget;
(function (StatisticTypeWidget) {
    StatisticTypeWidget[StatisticTypeWidget["SUNGLASSES"] = 0] = "SUNGLASSES";
    StatisticTypeWidget[StatisticTypeWidget["STARSTRUCK"] = 1] = "STARSTRUCK";
    StatisticTypeWidget[StatisticTypeWidget["FROWNING"] = 2] = "FROWNING";
})(StatisticTypeWidget || (exports.StatisticTypeWidget = StatisticTypeWidget = {}));
var AlertWidgetType;
(function (AlertWidgetType) {
    AlertWidgetType[AlertWidgetType["CENTIMETER"] = 0] = "CENTIMETER";
    AlertWidgetType[AlertWidgetType["TSHIRT"] = 1] = "TSHIRT";
    AlertWidgetType[AlertWidgetType["WARNING"] = 2] = "WARNING";
})(AlertWidgetType || (exports.AlertWidgetType = AlertWidgetType = {}));
var E_ClothesType;
(function (E_ClothesType) {
    E_ClothesType[E_ClothesType["NONE"] = 0] = "NONE";
    E_ClothesType[E_ClothesType["TOP"] = 1] = "TOP";
    E_ClothesType[E_ClothesType["BOTTOM"] = 2] = "BOTTOM";
    E_ClothesType[E_ClothesType["ENTIRE"] = 3] = "ENTIRE";
    E_ClothesType[E_ClothesType["BRASSIERE"] = 4] = "BRASSIERE";
    E_ClothesType[E_ClothesType["SHOES"] = 5] = "SHOES";
})(E_ClothesType || (exports.E_ClothesType = E_ClothesType = {}));
var E_GenderType;
(function (E_GenderType) {
    E_GenderType[E_GenderType["NONE"] = 0] = "NONE";
    E_GenderType[E_GenderType["MALE"] = 1] = "MALE";
    E_GenderType[E_GenderType["FEMALE"] = 2] = "FEMALE";
    E_GenderType[E_GenderType["UNKNOW"] = 3] = "UNKNOW";
})(E_GenderType || (exports.E_GenderType = E_GenderType = {}));
var E_FitType;
(function (E_FitType) {
    E_FitType[E_FitType["NONE"] = 0] = "NONE";
    E_FitType[E_FitType["REGULAR"] = 1] = "REGULAR";
    E_FitType[E_FitType["TIGHT"] = 2] = "TIGHT";
    E_FitType[E_FitType["LOOSE"] = 3] = "LOOSE";
})(E_FitType || (exports.E_FitType = E_FitType = {}));
var E_BodyArea;
(function (E_BodyArea) {
    E_BodyArea[E_BodyArea["NONE"] = 0] = "NONE";
    E_BodyArea[E_BodyArea["TOP"] = 1] = "TOP";
    E_BodyArea[E_BodyArea["BOTTOM"] = 2] = "BOTTOM";
    E_BodyArea[E_BodyArea["BOTH"] = 3] = "BOTH";
    E_BodyArea[E_BodyArea["UNKNOW"] = 4] = "UNKNOW";
})(E_BodyArea || (exports.E_BodyArea = E_BodyArea = {}));
var E_BodyPart;
(function (E_BodyPart) {
    E_BodyPart[E_BodyPart["NONE"] = 0] = "NONE";
    E_BodyPart[E_BodyPart["TALL"] = 1] = "TALL";
    E_BodyPart[E_BodyPart["HEAD"] = 2] = "HEAD";
    E_BodyPart[E_BodyPart["NECK"] = 3] = "NECK";
    E_BodyPart[E_BodyPart["SHOULDER"] = 4] = "SHOULDER";
    E_BodyPart[E_BodyPart["CHEST"] = 5] = "CHEST";
    E_BodyPart[E_BodyPart["BACK"] = 6] = "BACK";
    E_BodyPart[E_BodyPart["ARM"] = 7] = "ARM";
    E_BodyPart[E_BodyPart["WAIST"] = 8] = "WAIST";
    E_BodyPart[E_BodyPart["HIP"] = 9] = "HIP";
    E_BodyPart[E_BodyPart["LEG"] = 10] = "LEG";
    E_BodyPart[E_BodyPart["CROTCH"] = 11] = "CROTCH";
    E_BodyPart[E_BodyPart["UNDERBUST"] = 12] = "UNDERBUST";
    E_BodyPart[E_BodyPart["FOOT"] = 13] = "FOOT";
})(E_BodyPart || (exports.E_BodyPart = E_BodyPart = {}));
var E_MeasureType;
(function (E_MeasureType) {
    E_MeasureType[E_MeasureType["NONE"] = 0] = "NONE";
    E_MeasureType[E_MeasureType["LENGTH"] = 1] = "LENGTH";
    E_MeasureType[E_MeasureType["HIGH"] = 2] = "HIGH";
    E_MeasureType[E_MeasureType["CONTOUR"] = 3] = "CONTOUR";
})(E_MeasureType || (exports.E_MeasureType = E_MeasureType = {}));
var E_UnitMeasure;
(function (E_UnitMeasure) {
    E_UnitMeasure[E_UnitMeasure["NONE"] = 0] = "NONE";
    E_UnitMeasure[E_UnitMeasure["FT"] = 1] = "FT";
    E_UnitMeasure[E_UnitMeasure["CM"] = 2] = "CM";
    E_UnitMeasure[E_UnitMeasure["MT"] = 3] = "MT";
    E_UnitMeasure[E_UnitMeasure["GRS"] = 4] = "GRS";
    E_UnitMeasure[E_UnitMeasure["KG"] = 2] = "KG";
})(E_UnitMeasure || (exports.E_UnitMeasure = E_UnitMeasure = {}));
var E_ContractType;
(function (E_ContractType) {
    E_ContractType[E_ContractType["NONE"] = 0] = "NONE";
    E_ContractType[E_ContractType["FREE"] = 1] = "FREE";
    E_ContractType[E_ContractType["PRO"] = 2] = "PRO";
    E_ContractType[E_ContractType["ENTERPRISE"] = 3] = "ENTERPRISE";
})(E_ContractType || (exports.E_ContractType = E_ContractType = {}));
//# sourceMappingURL=types.js.map